<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar toolbar-dense">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Shipment Orders">Shipment Orders</span>
      </div>

      <!-- Center: Filter buttons + Labels toggle + Search -->
      <div class="app-toolbar-center">
        <!-- Filter toggles -->
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ALL')" (click)="toggleFilter('ALL')" i18n-title="@@All" title="All">
            <mat-icon>filter_list</mat-icon><span class="toolbar-btn-label" i18n="@@All">All</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('PENDING')" (click)="toggleFilter('PENDING')" i18n-title="@@Pending" title="Pending">
            <mat-icon>hourglass_empty</mat-icon><span class="toolbar-btn-label" i18n="@@Pending">Pending</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ON_HOLD')" (click)="toggleFilter('ON_HOLD')" i18n-title="@@On Hold" title="On Hold">
            <mat-icon>pause_circle</mat-icon><span class="toolbar-btn-label" i18n="@@On Hold">On Hold</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('SHIPPED')" (click)="toggleFilter('SHIPPED')" i18n-title="@@Shipped" title="Shipped">
            <mat-icon>local_shipping</mat-icon><span class="toolbar-btn-label" i18n="@@Shipped">Shipped</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('DELIVERED')" (click)="toggleFilter('DELIVERED')" i18n-title="@@Delivered" title="Delivered">
            <mat-icon>check_circle</mat-icon><span class="toolbar-btn-label" i18n="@@Delivered">Delivered</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ADDRESS_ISSUE')" (click)="toggleFilter('ADDRESS_ISSUE')" i18n-title="@@Address Issue" title="Address Issue">
            <mat-icon>report_problem</mat-icon><span class="toolbar-btn-label" i18n="@@Address Issue">Address Issue</span>
          </button>
        </div>

        <!-- Show/Hide Labels standalone toggle -->
        <button class="toolbar-filter-standalone" [class.active]="showSymbolMeanings" (click)="showSymbolMeanings=!showSymbolMeanings" [title]="showSymbolMeanings ? 'Hide Labels' : 'Show Labels'">
          <mat-icon>{{ showSymbolMeanings ? 'label' : 'label_off' }}</mat-icon>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Search -->
        <div class="toolbar-search">
          <mat-icon>search</mat-icon>
          <input type="text" (keyup)="onSearchInputChange($event)" i18n-placeholder="@@Search" placeholder="Search">
        </div>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="Shipment Orders"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div class="pageArea">
          <div class="mainOrdersArea">

            <div class="ordersTable">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="full-width-table">

                <!-- ID -->
                <ng-container matColumnDef="ID">
                  <th mat-header-cell *matHeaderCellDef i18n="@@ID">Id</th>
                  <td mat-cell *matCellDef="let row">{{ row.ID }}</td>
                </ng-container>

                <!-- Customer Order Id -->
                <ng-container matColumnDef="customerOrderId">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Customer Order Id">Customer Order Id</th>
                  <td mat-cell *matCellDef="let row">{{ row.order?.customerorderid }}</td>
                </ng-container>

                <!-- Created / Shipped (two dates stacked; shipped line only when actually shipped) -->
                <ng-container matColumnDef="created">
                  <th mat-header-cell *matHeaderCellDef>
                    <span i18n="@@Created">Created</span>
                    <span class="secondary-info"> / <ng-container i18n="@@Shipped">Shipped</ng-container></span>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="dates-cell">
                      <span>{{ row.order?.created | date: 'MM/dd/yy' }}</span>
                      <ng-container *ngIf="getShippedTimestamp(row) as shippedAt">
                        <span class="secondary-info">{{ shippedAt | date: 'MM/dd/yy' }}</span>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>

                <!-- Customer (name + full address, replaces name/company/address1/address2/city/state/country/postalcode) -->
                <ng-container matColumnDef="customer">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Customer">Customer</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="customer-cell">
                      <span class="primary-line">
                        {{ row.title ? row.title + ' ' : '' }}{{ row.firstname }}{{ row.lastname ? ' ' + row.lastname : '' }}{{ row.company ? ' — ' + row.company : '' }}
                      </span>
                      <span class="secondary-info">
                        {{ row.address1 }}{{ row.address2 ? ', ' + row.address2 : '' }}
                      </span>
                      <span class="secondary-info">
                        {{ row.city }}{{ row.state ? ', ' + row.state : '' }} {{ row.postalcode }}{{ row.country ? ', ' + row.country : '' }}
                      </span>
                    </div>
                  </td>
                </ng-container>

                <!-- Items (qty + title stacked, one per line) -->
                <ng-container matColumnDef="items">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Items">Items</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.orderItems && row.orderItems.length > 0; else noItems">
                      <table class="itemsTable">
                        <tr>
                          <td class="items-qty"><span *ngIf="showSymbolMeanings" i18n="@@Qty">Qty</span></td>
                          <td><span *ngIf="showSymbolMeanings" i18n="@@Title">Title</span></td>
                        </tr>
                        <tr *ngFor="let item of row.orderItems">
                          <td class="items-qty">{{ item.quantity }}</td>
                          <td>{{ (item.product?.title) || (productService.objectsById['' + item.product_ID]?.title) || ('#' + item.product_ID) }}</td>
                        </tr>
                      </table>
                    </ng-container>
                    <ng-template #noItems>
                      <span class="secondary-info">&mdash;</span>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- Carrier + Service -->
                <ng-container matColumnDef="carrier">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Carrier">Carrier</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="carrier-cell">
                      <span>{{ row.carrier }}</span>
                      <span class="secondary-info">{{ row.servicelevel }}</span>
                    </div>
                  </td>
                </ng-container>

                <!-- Tracking -->
                <ng-container matColumnDef="tracking">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Tracking">Tracking</th>
                  <td mat-cell *matCellDef="let row">
                    <a *ngIf="row.carriertrackingid" [href]="getTrackingLink(row.carriertrackingid)" target="_blank" i18n-title="@@Track Order">{{ row.carriertrackingid }}</a>
                  </td>
                </ng-container>

                <!-- Status -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Status">Status</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="status-cell">
                      <span>{{ getShipmentCategory(row) }}</span>
                      <span *ngIf="hasAddressIssue(row)" class="secondary-info" i18n="@@Address Issue">Address Issue</span>
                    </div>
                  </td>
                </ng-container>

                <!-- Actions (eye button to expand) -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Actions">Actions</th>
                  <td mat-cell *matCellDef="let row" class="actions-cell">
                    <button mat-icon-button (click)="toggleExpand(row, $event)"
                            [attr.aria-label]="expandedElement === row ? 'Hide details' : 'Show details'"
                            i18n-title="@@viewOrderDetails" title="View details">
                      <mat-icon>{{ expandedElement === row ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Expanded detail row -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="expanded-detail-cell">
                    <div class="expanded-detail-content" *ngIf="expandedElement === row">
                      <app-shipment-order [orderDeliverTo]="row"></app-shipment-order>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    class="element-row"
                    [class.expanded-row]="expandedElement === row"
                    [style.background-color]="getRowBackgroundColor(row)"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                    class="detail-row"
                    [class.detail-row-hidden]="expandedElement !== row"></tr>
              </table>

              <div *ngIf="!dataSource?.data?.length" class="no-data">
                <ng-container [ngSwitch]="orderDeliverToService.loadingState">
                  <span *ngSwitchCase="'LOADING'" i18n="@@Loading Data">Loading Data</span>
                  <span *ngSwitchCase="'ERROR'" i18n="@@Error Loading Data">Error Loading Data</span>
                  <span *ngSwitchDefault i18n="@@No Orders Found">No orders found.</span>
                </ng-container>
              </div>
            </div>

          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>






